import React from 'react';

interface Props {
  active: string;
  onChange: (key: string) => void;
}

const TABS = [
  { key: 'mine', label: 'Thư viện của tôi' },
  { key: 'system', label: 'Hệ thống' },
];

const LibraryTabs: React.FC<Props> = ({ active, onChange }) => (
  <div className="lib-tabs">
    {TABS.map((t) => (
      <button
        key={t.key}
        className={`lib-tab${active === t.key ? ' lib-tab--active' : ''}`}
        onClick={() => onChange(t.key)}
      >
        {t.label}
      </button>
    ))}
  </div>
);

export default LibraryTabs;
